import t from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const m = {
  display: "block"
}, f = ({ size: a = 16, useVw: o, useRem: e, color: i, withColor: c, removeClassName: n, disableSSR: d, style: l, ...p }) => {
  const h = l ? { ...m, ...l } : m;
  return /* @__PURE__ */ t.createElement(x, { disableSSR: d }, /* @__PURE__ */ t.createElement("svg", { "data-icon-id": "32px-yinhangkajiaoyi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: o ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (e ? "rem" : "px"), height: o ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (e ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: h, fill: "none", ...p }, /* @__PURE__ */ t.createElement(
    "g",
    {
      className: n ? "" : "32px-é¶è¡å¡äº¤æ"
    },
    /* @__PURE__ */ t.createElement(
      "path",
      {
        className: n ? "" : "normal",
        d: "M3.6 9.674A3.775 3.775 0 0 1 7.375 5.9h17.25A3.775 3.775 0 0 1 28.4 9.674V15a.9.9 0 1 1-1.8 0V9.674c0-1.09-.884-1.975-1.975-1.975H7.375c-1.09 0-1.975.885-1.975 1.975v.802c0 .738.598 1.336 1.336 1.336h16.325a.9.9 0 1 1 0 1.8H6.736A3.136 3.136 0 0 1 3.6 10.476v-.802Zm.9 6.926a.9.9 0 0 1 .9.9v4.793c0 1.09.884 1.974 1.975 1.974H15.5a.9.9 0 1 1 0 1.8H7.375A3.775 3.775 0 0 1 3.6 22.293V17.5a.9.9 0 0 1 .9-.9Zm20.081 1.235a.9.9 0 0 1 1.272.059l2.012 2.206a.9.9 0 0 1-.665 1.506H20a.9.9 0 1 1 0-1.8h5.161l-.638-.7a.9.9 0 0 1 .058-1.27Zm-3.267 8.738a.9.9 0 0 0 1.339-1.203l-.634-.705h5.15a.9.9 0 0 0 0-1.8H20a.9.9 0 0 0-.67 1.501l1.984 2.207Z",
        fill: c ? r(i, 0, "#262933") : "#262933",
        datafollowfill: c ? r(i, 0, "#262933") : "#262933"
      }
    )
  )));
}, H = f;
export {
  H as default
};
